import { useState, useEffect } from 'react';
import './css/Style.css';
import { Link, useSearchParams } from 'react-router-dom';
import { SideMenu } from '../../../components/SideMenu';
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import { ShowFadeInUpSection } from '../../../components/ShowFadeInUpSection';
import { ShowFadeLeftRightSection } from '../../../components/ShowFadeLeftRightSection';
import { ShowFadeRightLeftSection } from '../../../components/ShowFadeRightLeftSection';
import { ShowFadeHidden } from '../../../components/ShowFadeHidden';
import { NavBarSiteV1 } from '../../../components/NavBarSite/_v1/Index';
import { FooterSiteV1, FooterSiteV1Style } from '../../../components/FooterSite/v1';
import svg_pega_preco from '../../global/img/pega_preco.svg'
import { PhoneInput } from '../../../components/PhoneInput/PhoneInput';
import { API_END_POINT_FORM_PARCEIROS } from '../../../api/base';
import { LINKS_CENTRAL_DE_AJUDA, LINKS_EMAIL_COMERCIAL_TOOME, LINKS_TERMOS, LINKS_WHATSAPP } from '../../../Links';

function Estabelecimentos() {

    const [searchParams, setSearchParams] = useSearchParams();
    const [state, setState] = useState(false);

    const cards = [
        {
            titulo: 'Mural de Ofertas',
            img: require('./img/ap-mural.avif'),
            texto: 'Mostre seus produtos principais, eles serão exibidos nos banneres para todos os usuários que acessarem o aplicativo do TooMe!'
        },
        {
            titulo: 'Sugestão nas Pesquisas',
            img: require('./img/sugestao.avif'),
            texto: 'Seus produtos podem aparecer no topo das pesquisas iniciais, quando um cliente começar a digitar o nome do produto no buscador do TooMe.'
        },
        {
            titulo: 'Mapa de Ofertas',
            img: require('./img/ap-mapa.avif'),
            texto: 'Unificação das suas ofertas, ícone com a logo do estabelecimento e uma mensagem com exibição intermitente e personalizada.'
        },
        {
            titulo: 'Perfil do Mercado',
            img: require('./img/ap-perfil.avif'),
            texto: 'Você pode personalizar anúncios, mostrar ofertas, exibir encartes e muito mais, garantindo um maior direcionamento das promoções.'
        },
        {
            titulo: 'Lista Inteligente',
            img: require('./img/ap-lista.avif'),
            texto: 'Os anúncios do mercado podem aparecer no topo da lista quando os clientes pesquisarem ofertas, indicando uma promoção patrocinada.'
        },
        {
            titulo: 'Cupons e Eventos',
            img: require('./img/ap-eventos.avif'),
            texto: 'Divulgue seus eventos, insira seus cupons de descontos ou publique ofertas e promoções no banner disponível nessa seção.'
        },
        {
            titulo: 'Joguinhos do TooMe!',
            img: require('./img/ap-jogo2.avif'),
            texto: 'Você pode posicionar a sua marca em toda a mecânica dos jogos no Tô no mercado, e os clientes ganham pontos e se divertem.'
        },
        {
            titulo: 'Topo das Buscas',
            img: require('./img/ap-busca.avif'),
            texto: 'Quando os usuários pesquisam o preço de um item, seu produto pode aparecer no topo dos resultados como uma oferta recomendada'
        }
    ]

    useEffect(() => {
        if (!state) {
            setState(true);
        } else {
            ShowFadeInUpSection('secao_sobre');
            ShowFadeInUpSection('vantagens-mercado');
            ShowFadeInUpSection('apoio-pequeno-mercado');
            ShowFadeInUpSection('container-ref');
            ShowFadeInUpSection('ilustracao');
            ShowFadeInUpSection('painel-estabelecimento');
            ShowFadeInUpSection('texto');
            ShowFadeInUpSection('onde-aparece');
            ShowFadeInUpSection('secao_pesquisa');
            // ShowFadeInUpSection('sustentabilidade');
            ShowFadeInUpSection('duv');
            ShowFadeInUpSection('contato');
            ShowFadeInUpSection('contato-parceiro');

            {
                {
                    ShowFadeHidden('anim-left-right-titulo');
                    ShowFadeHidden('anim-left-right-cliente-1');
                    ShowFadeHidden('anim-right-left-toome1-1');
                    ShowFadeHidden('anim-left-right-cliente-2');
                    ShowFadeHidden('anim-right-left-toome1-2');
                }
                {
                    const tempoMensagens = 0.6;
                    ShowFadeLeftRightSection('anim-left-right-titulo', tempoMensagens);

                    const tempoEntreMensagens = 1;
                    ShowFadeLeftRightSection('anim-left-right-cliente-1', tempoEntreMensagens, () => {
                        ShowFadeRightLeftSection('anim-right-left-toome1-1', tempoEntreMensagens, () => {
                            ShowFadeLeftRightSection('anim-left-right-cliente-2', tempoEntreMensagens, () => {
                                ShowFadeRightLeftSection('anim-right-left-toome1-2', tempoEntreMensagens);
                            });
                        });
                    });
                }
            }

            const message = searchParams.get('message');
            if (message) {
                alert(message);
                window.location.href = `#/opc_gerais/estabelecimentos/`
            }

            const faqSection = document.getElementById('js_link_container_fac');
            const js_container_fac = document.getElementById('js_container_fac');
            const faq_topic = document.getElementsByName("faq_topic");
            if (faqSection !== null && js_container_fac !== null && faq_topic !== null) {
                js_container_fac.style.display = '';
                faqSection.addEventListener('click', function () {
                    js_container_fac.style.display = js_container_fac.style.display == '' ? 'block' : '';
                });
                faq_topic.forEach(function (topic) {
                    topic.addEventListener('click', function () {
                        const answer = this.nextElementSibling;
                        answer.style.display = (answer.style.display === 'none' || answer.style.display === '') ? 'block' : 'none';
                        if (!topic.classList.contains('faq_topic_sel'))
                            topic.classList.add('faq_topic_sel')
                        else
                            topic.classList.remove('faq_topic_sel')
                    });
                    topic.click();
                    topic.click();
                });
            }

            const furl_redirect = document.getElementById('furl_redirect');
            if (furl_redirect !== null)
                furl_redirect.value = window.location.href;
            function muralGetURLParam(param) {
                const parametros = window.location.href.substring(1).split('&');
                for (let i = 0; i < parametros.length; i++) {
                    const parametro = parametros[i].split(param + '=');
                    if (parametro.length == 2)
                        return parametro[1];
                }
                return null;
            }
            const msg_alerta = muralGetURLParam('msg_alert');
            if (msg_alerta !== null) {
                window.alert(msg_alerta.replace(/%20/g, " "));
                setTimeout(() => {
                    const gotoNextPage = window.parent.document.getElementById('gotoNextPage');
                    if (gotoNextPage !== null) {
                        gotoNextPage.style.animation = '.2s linear forwards gotoNextPageAnimeSlideClose';
                        gotoNextPage.src = '#/anim/';
                    }
                }, 30);

                setTimeout(() => {
                    window.parent.document.querySelectorAll("html")[0].style.overflow = "auto";
                    window.parent.scrollTo({ top: localStorage.getItem("LSTOR_Y_SCROLL_MURAL_TO_BACK_GROUND"), behavior: "instant" });
                }, 1);
            }

        }
        const partnerLink = document.querySelector('.partner-link');
        const targetSection = document.querySelector('#vantagens-section');

        if (partnerLink && targetSection) {
            partnerLink.addEventListener('click', (event) => {
                event.preventDefault();
                targetSection.scrollIntoView({ behavior: 'smooth' });
            });
        }

    }, [state]);

    return (
        <>
            <NavBarSiteV1 />
            {state &&
                <>
                    <main className='container_estabelecimentos'>

                        <div className="foto">
                            {window.screen.width > 620
                                ? <img
                                    className="img1"
                                    src={require("./img/11.avif")}
                                    alt="Banner desktop de um homem segurando celular no mercado"
                                    width={1400}
                                    height={646}
                                    loading='lazy'
                                />
                                : <img
                                    className="img2"
                                    src={require("./img/12.avif")}
                                    alt="Banner mobile de um homem segurando celular no mercado"
                                    width={620}
                                    height={424}
                                    loading='lazy'
                                />
                            }
                            <h1 className="anim-left-right-titulo">
                                Coloque o seu <b>mercado em</b> uma posição de <b>destaque!</b>
                            </h1>
                        </div>

                        <section className="secao_sobre">

                            <p><b>Sabe por que o TooMe é ideal para o seu mercado?</b><br /><br />O <b className='destacar'>tô no mercado</b> não cobra comissão sobre cada produto vendido pelo mercado. O que queremos é construir uma parceria em que os próprios clientes se tornem divulgadores dos seus produtos, sem altos custos com tecnologia e com os mercados no radar do clientes em uma <b className='destacar'>posição de destaque</b>.</p>

                        </section>

                        <section className="vantagens-mercado">
                            <div>
                                <h2>Benefícios que o TooMe trás para seu o mercado!</h2>
                                <p>Com o TooMe, seu mercado ganha visibilidade, tecnologia e engajamento com baixo custo e alto impacto.</p>

                                <div>
                                    <div >📦 Centralização das suas ofertas.</div>
                                    <div >📍 Seu mercado no radar dos clientes.</div>
                                    <div >📢 Clientes como agentes de divulgação.</div>
                                    <div >🔒 Acesso a uma área exclusiva.</div>
                                    <div >📡 Alertas e notificações geolocalizadas.</div>
                                    <div >🧠 Notificações por hábitos ou buscas.</div>
                                    <div >🖼️ Anúncios em várias seções.</div>
                                    <div >🎯 Total controle do alcance dos anúncios.</div>
                                    <div >🚀 Potencialização do seu programa de benefícios.</div>
                                    <div >🗺️ Comunicação pelo mapa das ofertas.</div>
                                    <div >💸 Sem altos custos em tecnologia.</div>
                                    <div >🛠️ Em breve, um painel de controle exclusivo.</div>
                                </div>
                            </div>
                        </section>

                        {/* <hr className="linha" /> */}

                        <section className='apoio-pequeno-mercado' id="apoio-pequeno-mercado">
                            <div className="container">
                                <div className="texto">
                                    <h2>
                                        O <b>TooMe</b> é um aliado de quem faz o <br />
                                        <span className="destaque">comércio local acontecer</span>
                                    </h2>
                                    <p>
                                        Apoiamos os pequenos mercados, oferecendo acesso diferenciado para
                                        quem mais precisa. Além de maior visibilidade no app, esses negócios
                                        ganham espaço segmentado, oportunidades de crescimento e acesso a
                                        informações estratégicas que antes não tinham, tudo isso sem altos
                                        custos em tecnologia e{" "}
                                        <b>mantendo o mercado no radar dos clientes!</b>
                                    </p>
                                    <a href={LINKS_WHATSAPP} target='_blank' className="btn-parceiro">
                                        Seja um Parceiro TooMe
                                    </a>
                                </div>

                                <div className="ilustracao">
                                    <img src={require('./img/13.avif')} alt="Apoio ao comércio local" />
                                </div>
                            </div>
                        </section>

                        {/* <hr className="linha" /> */}

                        <section className='container-ref container_fundo_decorativo_1'>

                            <h2><b>Seja lembrado sempre!</b> Apareça no TooMe e torne-se um <u>supermercado de referência</u> quando os clientes procurarem ofertas.</h2>

                            <div>
                                <img
                                    src={require('./img/estab.avif')}
                                    alt='Mulher com roupa de atendente de supermercado'
                                    loading='lazy'
                                    width={246}
                                    height={369}
                                />

                                <section>
                                    <div className="cliente anim-left-right-cliente-1">
                                        <p>Quero mais visibilidade para o meu mercado. Como consigo isso?</p>
                                    </div>
                                    <div className="toome1 anim-right-left-toome1-1">
                                        <p>Olá! O TooMe coloca você no radar dos clientes, transformando os usuários em divulgadores dos seus produtos! 📢📱</p>
                                    </div>
                                    <div className="cliente anim-left-right-cliente-2">
                                        <p>Sério? E como eu faço isso?</p>
                                    </div>
                                    <div className="toome1 anim-right-left-toome1-2">
                                        <p>É simples! Cadastre seu mercado para ser parceiro do TooMe.<br />Rápido, fácil e eficiente! 🚀</p>
                                    </div>
                                </section>
                            </div>

                            <p>Os clientes pesquisam, comparam e decidem antes mesmo de sair de casa. Se o seu mercado aparece nesse momento de decisão, você já sai na frente.
                                <b> O cliente precisa ir ao mercado, e o TooMe mostra qual ele deve escolher. </b>Simples assim!</p>

                        </section>

                        <section className="painel-estabelecimento">
                            <div>
                                <div>
                                    <h2>Um painel de controle só seu.</h2>
                                    <p>Em breve, os estabelecimentos parceiros terão acesso a uma área exclusiva com <b>métricas em tempo real</b>, <b>dashboard de performance</b> e <b>indicadores estratégicos</b> que mostram exatamente o alcance e impacto das suas ofertas.</p>
                                    <p>É o jeito TooMe de colocar o controle na palma da sua mão, com dados, eficiência e resultados.</p>
                                    <p className="chamada">Prepare-se para uma nova era de visibilidade e inteligência comercial.</p>
                                </div>

                                <div className="ilustracao">
                                    <img
                                        src={require('./img/1055644.png')}
                                        alt="Dashboard ilustrativo"
                                        loading='lazy'
                                        width={348}
                                        height={348}
                                    />
                                </div>
                            </div>
                        </section>

                        <section>

                        </section>

                        <section className='onde-aparece'>

                            <h2><b>Lugares</b> que você aparece:</h2>

                            <p >O TooMe é uma plataforma exclusiva e não uma extensão de aplicativos. Queremos mudar a forma como as compras acontecem, as pessoas economizam e valorizam o setor.</p>
                            <br id="vantagens-section" />

                            <section >
                                <Swiper
                                    modules={[Autoplay, Pagination]}
                                    spaceBetween={20}
                                    slidesPerView={1}
                                    autoplay={{ delay: 3500, disableOnInteraction: false }}
                                    pagination={{ clickable: true }}
                                    loop={true}
                                    breakpoints={{
                                        640: { slidesPerView: 1.2 },
                                        768: { slidesPerView: 2 },
                                        1024: { slidesPerView: 3 }
                                    }}
                                >
                                    {cards.map((card, index) => (
                                        <SwiperSlide key={index}>
                                            <div className='card_anuncio'>
                                                <h1><b>{card.titulo}</b></h1>
                                                <img
                                                    src={card.img}
                                                    alt={card.titulo}
                                                    width={600}
                                                    height={1269}
                                                    loading='lazy'
                                                />
                                                <p>{card.texto}</p>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </section>

                        </section>

                        <section className="contato-parceiro">
                            <div>
                                <h2>Deseja ser um mercado parceiro ou patrocinar o TooMe?</h2>
                                <p>Preencha o formulário abaixo ou entre em contato direto conosco pelo WhatsApp ou por e-mail.</p>

                                <form
                                    method="post"
                                    action={API_END_POINT_FORM_PARCEIROS}
                                >
                                    {/* name, email, phone, subject, comment */}
                                    <div>
                                        <input type="text" name="name" placeholder="Nome *" required />
                                        <input type="email" name="email" placeholder="E-mail *" required />
                                    </div>
                                    <div>
                                        <PhoneInput
                                            allowLabel={false}
                                            id={'phone'}
                                        />
                                        <input type="text" name="subject" placeholder="Assunto *" required />
                                    </div>
                                    <textarea name="comment" placeholder="Mensagem rápida..." rows="3" required></textarea>
                                    <button type="submit">📨 Enviar</button>

                                    <p>
                                        <label>
                                            <input type="checkbox" id="aceite" required />
                                            Ao se cadastrar, você aceita nossa <a href={LINKS_TERMOS} target='_blank'>Política de privacidade</a> sobre os dados fornecidos.
                                        </label>
                                    </p>
                                    <input style={{ display: 'none' }} disabled name="param" defaultValue={window.location.hash} />
                                </form>

                                <div>
                                    <a
                                        href={LINKS_WHATSAPP}
                                        target="_blank"
                                        className="btn-whatsapp"
                                    >💬 Falar no WhatsApp</a>
                                    <a
                                        href={LINKS_EMAIL_COMERCIAL_TOOME}
                                        className="btn-email"
                                    >📧 comercial@tonomercado.com.br</a>
                                </div>
                            </div>
                        </section>

                        <section className='secao_pesquisa'>

                            <h1>Entendemos as dificuldades dos clientes:</h1>

                            <div>
                                <div className="card_pesquisa">
                                    <span>96,5%</span>
                                    <p>Comentam as ofertas com outras pessoas.</p>
                                </div>

                                <div className="card_pesquisa">
                                    <span>92,0%</span>
                                    <p>Entrariam em um mercado se soubessem que, naquele momento, há uma promoção de interesse disponível.</p>
                                </div>

                                <div className="card_pesquisa">
                                    <span>82,1%</span>
                                    <p>Fazem compras toda semana.</p>
                                </div>

                                <div className="card_pesquisa">
                                    <span>77,7%</span>
                                    <p>Mudariam de mercado para aproveitar uma oferta.</p>
                                </div>

                                <div className="card_pesquisa">
                                    <span>71,4%</span>
                                    <p>Realizariam atividades no mercado para ganhar benefícios.</p>
                                </div>

                                <div className="card_pesquisa">
                                    <span>66,0%</span>
                                    <p>Consideram o preço como fator fundamental na hora de decidir suas compras.</p>
                                </div>

                            </div>

                            <b>A pesquisa completa indicou uma forte intenção por ofertas centralizadas que ajude na economia de tempo e dinheiro. O <b>TooMe</b> tem o potencial de atender as demandas, oferecendo uma plataforma intuitiva e abrangente, tornando-se essencial na busca por ofertas e benefícios.</b>

                        </section>

                        <div className='duv'>
                            <p className='duvida'>Ficou alguma dúvida?</p>
                            <div
                                className='text_mail'
                                id="js_link_container_fac">
                                <u className='GLOBAL_PC_MOUSE_HOVER PerguntasFrequentes'
                                >Ir para as perguntas frequentes 🖊
                                </u>
                            </div>
                        </div>

                        <div className='faq_section' id="js_container_fac">
                            <section className='espaco'>
                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Como posso me tornar uma marca ou estabelecimento parceiro do TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>A equipe do TooMe está desenvolvendo uma área exclusiva para os parceiros. Enquanto isso, você pode se cadastrar para receber nosso contato com os procedimentos e mais informações. Para isso, entre em contato pelo nosso whatsApp <Link style={{ color: '#d65616e2' }} to={LINKS_WHATSAPP} target='blank' ><b>(45)98819-1601</b></Link> para discutir uma parceria e incluir sua marca ou estabelecimento no TooMe. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>

                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Quais são os benefícios de ser um parceiro do TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Os parceiros do TooMe possuem uma série de benefícios que deixam seu estabeleciemnto em uma posição de destaque, pois o que o aplicativo faz, nenhuma outra plataforma proporciona, entre as principais vantagens estão: Personalização do ambiente virtual do estabelecimento, sem altos custos em tecnologia; seu mercado no radar dos clientes; centralização das suas ofertas; clientes como agentes de divulgação; alertas e notificações geolocalizadas; notificações por hábitos ou buscas; anúncios em várias seções; total controle do alcance dos anúncios; potencialização do seu programa de benefícios; comunicação pelo mapa das ofertas; acesso à personalização dos jogos patrocinados e muito mais. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>O TooMe oferece dados analíticos sobre o comportamento dos consumidores?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Sim, oferecemos relatórios e análises detalhadas sobre o comportamento dos consumidores para ajudar os parceiros a entender melhor suas necessidades e preferências. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Quais são as principais funcionalidades que o painel de controle dos mercados terá?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>As principais funcionalidades que os parceiros contarão serão: inclusão de anúncios em várias seções do aplicativo; inclusão de banner de destaque na tela principal do aplicativo e na sua área exclusiva; modelagem dos jogos patrocinados; acesso a dados analíticos; envio de ofertas por hábito, por buscas e de forma ampla; inclusão de encartes e alertas por geolocalização; personalização do seu ambiente; mensagens no mapa das ofertas; contratação e renovação de parcerias; inclusão da logomarca; compra de pacotes; suporte personalizado e muitas outras funcionalidades. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Como os jogos e desafios do TooMe podem beneficiar minha marca?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Os jogos e desafios no TooMe podem ser patrocinados, proporcionando uma maneira divertida e educativa de promover produtos e engajar os consumidores. Inserimos sua marca e/ou seus produtos no ambiente do jogo, destacando seu estabelecimento. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Quais tipos de suporte o TooMe oferece aos seus parceiros?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Oferecemos suporte técnico e uma assistência personalizada para maximizar os benefícios da parceria com o TooMe. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Sou investidor, posso participar do TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Interessados em investir no TooMe podem entrar em contato conosco para discutir oportunidades de investimento e participar do crescimento da plataforma. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>O TooMe possui um modelo de negócios sustentável?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Sim, o TooMe é projetado para ser financeiramente sustentável através de parcerias, publicidade e serviços premium. </p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Como minha empresa pode contribuir para as iniciativas sustentáveis do TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Como o aplicativo atua nas 3 dimensões da sustentabilidade, apenas em ser parceiro, patrocinador ou investindo no TooMe, você já está fazendo a sua partes, mas também, as empresas podem patrocinar etapas bônus nos joguinhos do TooMe e desafios focados em sustentabilidade, além poderem participar de campanhas e projetos promovidos dentro do aplicativo. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>O TooMe possui algum programa de fidelidade para clientes?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Sim, atualmente o TooMe está finalizando o programa chamado "Carimbo de Benefícios" para engajar, atuar no marketing e manter a permanência dos clientes por longos prazos. Além disso, estamos desenvolvendo outros programas de fidelidade que recompensarão os clientes por seu engajamento e uso do aplicativo. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Quais são as taxas associadas à parceria com o TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>As taxas variam de acordo com o nível de parceria e pacote de serviços oferecidos. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> para obter um detalhamento específico.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Como posso acompanhar o desempenho das minhas promoções no TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Os parceiros têm acesso a um relatório pré e pós publicação. Além disso, estamos finalizando um painel de controle onde podem monitorar o desempenho de suas promoções e ofertas em tempo real. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> e saiba mais.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>O TooMe oferece integração com sistemas de gestão de supermercados?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Sim, basta apenas entrar em <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>contato</Link> para que possamos fazer essa integração. Com os preços atualizados, seus clientes conseguem te encontrar e comprar com mais assertividade.</p>
                                </div>

                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Como posso anunciar no TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p><Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link> para discutir as opções de publicidade disponíveis e como podemos ajudar a promover sua marca dentro do aplicativo. Lembrando que em breve, o TooMe terá uma área exclusiva para os estabelecimentos.</p>
                                </div>

                            </section>

                        </div>

                        <section className="contato">
                            <img
                                src={svg_pega_preco}
                                alt="Imagem do mascote do TooMe com nome de: Pega Preço"
                                loading='lazy'
                                width={240}
                                height={240}
                            />
                            <p>Se precisar, acesse a <b><Link to={LINKS_CENTRAL_DE_AJUDA}>central de ajuda. </Link></b><br />ou<br />Envie um e-mail para <b>comercial@tonomercado.com.br</b></p>
                        </section>
                        <br />
                        <FooterSiteV1 _FooterSiteV1Style={FooterSiteV1Style.style_1} />
                    </main >
                    <SideMenu />
                </>
            }
        </>
    )
}

export default Estabelecimentos;